<template>
  <v-app>
    <snackbar></snackbar>
    <v-fade-transition mode="out-in">
      <component :is="component">
        <slot></slot>
      </component>
    </v-fade-transition>
  </v-app>
</template>

<script>
  import { mapState } from 'vuex'
  import { isMobile } from 'mobile-device-detect'
  import auth from '../mixins/auth'
  import mqtt from '../mixins/mqtt'
  import Snackbar from './pages/_layouts/components/Snackbar'
  import Auth from './pages/_layouts/Auth'
  import Home from './pages/_layouts/Home'

  export default {
    name: 'app',
    mixins: [auth, mqtt],
    components: {Snackbar, Auth, Home},
    data: () => ({
      loading: false,
      matched: null
    }),
    computed: {
      ...mapState({
        mqttFailed: state => state.mqttFailed,
        mqttMessages: state => state.mqttMessages
      }),
      component () {
        if (this.$route.path.indexOf('auth') > -1) {
          return 'auth'
        } else {
          return 'home'
        }
      }
    },
    watch: {
      '$route' () {
        // 更新前端路由信息，以便后续的ajax请求能够携带正确的header信息
        this.cachePath()
        // 检查路由匹配到的组件
        this.getMatched()
      },
      '$store.state.logoutTag' () {
        if (!this.deactivating) {
          this.deactivate()
        }
      },
      pages () {
        this.addRoutes()
      },
      mqttFailed (failed) {
        if (failed) {
          this.initMqtt(true)
          this.$store.commit('assignValue', {
            mqttFailed: false
          })
        }
      },
      mqttMessages () {
        this.emitEvent(_.first(this.mqttMessages))
      }
    },
    methods: {
      checkMobile () {
        if (isMobile) {
          window.location.href = 'https://www.yundangdang.com'
        }
      },
      cachePath () {
        if (['/', '/auth'].indexOf(this.$route.path) === -1) {
          localStorage.setItem('path', this.$route.fullPath)
        }

        this.$store.commit('assignValue', {
          path: this.$route.path
        })
      },
      emitEvent (message) {
        if (_.get(message, 'type')) {
          this.$bus.$emit(message.type, message)
          this.$store.commit('shiftMqttMessage')
        }
      },
      listenKey () {
        addEventListener('resize', () => {
          this.$bus.$emit('resize', true)
        })
        addEventListener('keydown', e => {
          if (e.key === 'Escape') {
            this.$bus.$emit('key:escape', true)
          }
        })
      },
      getMatched () {
        let components = this.$router.getMatchedComponents()
        if (components.length > 0) {
          this.matched = components[0].name
        } else {
          this.matched = null
        }
      }
    },
    created () {
      this.checkMobile()
    },
    mounted () {
      this.listenKey()
      this.getMatched()

      this.initMqtt()
      this.activate()
    }
  }
</script>
